export default class PlayListManager {
    constructor(_option){
        this.nameIs = 'class-PlayListManager';

        this.option = _option;
        this.list = this.option.list;

        this.nowNum = 0;
        this.nowObj = this.list[this.nowNum];
    }

    init(){
    }

    next(){
        this.nowNum++;
        if( this.list.length-1 < this.nowNum ) this.nowNum = 0;
        this.nowObj = this.list[this.nowNum];

        return this.nowVodData;
    }
    
    go(_num){
        this.nowNum = _num;
        if( this.list.length-1 < this.nowNum || this.nowNum<0 ) this.nowNum = 0;
        this.nowObj = this.list[this.nowNum];

        return this.nowVodData;
    }

    get nowVodData(){
        return { 
            id: this.nowObj.id,
            videoId: this.nowObj.youtubeId, 
            startSeconds: this.nowObj.startSeconds,
            endSeconds: this.nowObj.endSeconds,
            title: this.nowObj.title,
            desc: this.nowObj.desc
        };
    }

    update(_total, _current){
        if(this.nowObj.endSeconds <= _current){
            this.next();
            $(this.option.el_sel).trigger({type: 'REACH_END_TIME', who:this.nameIs});
        }
    }
    
} // end of class